import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchManyInputModule } from '../../base/fc-search-many-input/fc-search-many-input.module';
import { FcStoragesInputComponent } from './fc-storages-input.component';


@NgModule({
  declarations: [
    FcStoragesInputComponent
  ],
  imports: [
    FcSearchManyInputModule,
    TranslateModule
  ],
  exports: [
    FcStoragesInputComponent
  ]
})
export class FcStoragesInputModule {}
